
// $(function(){
//     $(window).on('load scroll resize',function(){
//         var nowPosition = $(window).scrollTop();
//         var windowHeight = $(window).height();
//         if(nowPosition >= windowHeight){
//             $('header').addClass('change-color');
//         }else{
//             $('header').removeClass('change-color');
//         }
//     })
// })


$(window).scroll(function () {
  if($(window).scrollTop() > 0) {
    $('header').addClass('change-color');
    $('header').addClass('change-color');
  } else {
    $('header').removeClass('change-color');
    $('header').removeClass('change-color');
  }
});




$(document).ready(function(){
$('.header__icon--menu').on('touchstart click', function(event) {
  setTimeout(() => {
    if ($("#Details-menu-drawer-container").hasClass("menu-opening")) {
    $('header').addClass('change-color_02');
    $('.header__icon').addClass('icon-changeColor');
    } else{
    $('header').removeClass('change-color_02');
    $('.header__icon').removeClass('icon-changeColor');
    }
  },0.5)
});
});



// $(document).on("click", ".header__icon--menu", function(){
//   setTimeout(() => {
//     if ($("#Details-menu-drawer-container").hasClass("menu-opening")) {
//     $('header').addClass('change-color_02');
//     } else{
//     $('header').removeClass('change-color_02');
//     }
//   },1)
// });




